import Vue from 'vue'
import Notify from 'vue-notifyjs'

import 'vue-notifyjs/themes/material.scss'

Vue.use(Notify, {
  timeout: 5000,
  horizontalAlign: 'right',
  verticalAlign: 'bottom',
  transitionName: 'notification-list',
  transitionMode: 'out-in'
})
